import { Chip, ListItemIcon, MenuItem, Select, Stack } from "@mui/material";
import { MDBIcon } from "mdb-react-ui-kit";
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";
import './TechnicalEnvironment.css'
import { GrFormCheckmark } from "react-icons/gr";
import { ResumeContext } from "../../../../context/resume/resume-context";
import { TranslationContext } from "../../../../context/translations/translations-context";

export default function TechnicalEnvironment(
    {
        value,
        handleChangeTechnicalEnvironment,
    }
) {
    const { displayLanguage, translations } = useContext( TranslationContext );
    const { chosenBusinessSkills } = useContext( ResumeContext );
    const safeValue = Array.isArray( value ) ? value : [];
    const needNormalization = safeValue.some(
        skill => typeof skill === "string" || typeof skill === "number"
    );
    const [ open, setOpen ] = useState( false );

    const normalize = ( item ) => {
        if ( typeof item === "string" ) {
            // Only the label (unknown language) was stored in DB
            return chosenBusinessSkills.find(
                skill => Object.values( skill.translations ).includes( item )
            );
        } else if ( typeof item === "number" ) {
            // The id was stored in DB
            return chosenBusinessSkills.find( skill => skill.id === item );
        } else {
            return item;
        }
    }

    useEffect( () => {
        // Normalization, should occur on once per parent's item
        if ( !needNormalization ) {
            return;
        }
        const newValue = safeValue.map( normalize ).filter( Boolean );
        handleChangeTechnicalEnvironment( newValue );
    }, [ needNormalization, safeValue, chosenBusinessSkills ] );

    const handleChange = ( event ) => {
        setOpen( false );
        const newValue = event.target.value.map( normalize ).filter( Boolean );
        handleChangeTechnicalEnvironment( newValue )
    };

    const handleDelete = ( skillId ) => {
        const updatedValue = safeValue.filter( skill => skill.id !== skillId );
        handleChangeTechnicalEnvironment( updatedValue )
    };

    return (
        <Select
            open={ open }
            onOpen={ () => setOpen( true ) }
            onClose={ () => setOpen( false ) }
            multiple
            variant="standard"
            value={ safeValue.map( skill => skill.id ) }
            displayEmpty
            renderValue={ ( selected ) => {
                if ( selected.length === 0 ) {
                    return (
                        <span style={ { color: "#9aa3ab", fontStyle: "italic" } }>
                            { translations.experiencesSection.techEnvironmentPlaceholder }
                        </span>
                    );
                }
                return (
                    <Stack
                        className="skill-stack"
                        direction="row"
                        spacing={ { xs: 1, sm: 1 } }
                        useFlexGap
                        sx={ { flexWrap: 'wrap' } }
                    >
                        { selected.map( ( skillId ) => {
                                const skill = chosenBusinessSkills
                                    .find( skill => skill.id === skillId );
                                if ( !skill ) {
                                    return null;
                                }
                                return <Chip
                                    key={ skill.id }
                                    label={ skill.translations?.[ displayLanguage ] || skill.name || '' }
                                    onDelete={ () => {
                                        handleDelete( skill.id )
                                    } }
                                    deleteIcon={
                                        <MDBIcon
                                            far
                                            icon="trash-alt"
                                            className="skill-delete-action"
                                            role="button"
                                            onMouseDown={ ( event ) => event.stopPropagation() }
                                            style={ { cursor: 'pointer' } }
                                        />
                                    }
                                />
                            }
                        ) }
                    </Stack>
                );
            } }
            onChange={ handleChange }
        >
            { chosenBusinessSkills.map(
                skill => {
                    return (
                        <MenuItem
                            key={ skill.id }
                            value={ skill.id }
                            sx={ { justifyContent: "space-between" } }
                        >
                            { skill.translations?.[ displayLanguage ] || skill.name || '' }
                            { safeValue.some( val => val.id === skill.id ) ?
                                <ListItemIcon>
                                    <GrFormCheckmark/>
                                </ListItemIcon> : null }
                        </MenuItem>
                    )
                }
            ) }
        </Select>
    );
}
TechnicalEnvironment.propTypes = {
    value: PropTypes.array.isRequired,
    handleChangeTechnicalEnvironment: PropTypes.func.isRequired,
}
